module.exports = __webpack_public_path__ + "img/img／3 (1).1a54f835.png";